import { httpClient } from './httpClient';

export interface KeyFinding {
  id: string;
  caseId: string;
  eventId: string | null;
  selectedText: string | null;
  startOffset: number | null;
  endOffset: number | null;
  note: string | null;
  userId: string;
  eventHeadline: string | null;
  eventDate: string | null;
  eventType: string | null;
  createdAt: string;
}

export interface AddKeyFindingRequest {
  eventId?: string | null;
  selectedText?: string | null;
  startOffset?: number | null;
  endOffset?: number | null;
  note?: string | null;
}

export const keyFindingsApi = {
  getForCase: async (caseId: string): Promise<KeyFinding[]> => {
    try {
      return await httpClient.get<KeyFinding[]>(`/key-findings/case/${caseId}`);
    } catch (error: any) {
      // Return empty array if endpoint not found (gateway not restarted yet, etc.)
      if (error?.message?.includes('404')) return [];
      throw error;
    }
  },

  add: async (caseId: string, request: AddKeyFindingRequest): Promise<KeyFinding> => {
    return httpClient.post<KeyFinding>(`/key-findings/case/${caseId}`, request);
  },

  remove: async (findingId: string): Promise<void> => {
    await httpClient.delete(`/key-findings/${findingId}`);
  },
};
